import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import PageCardShimmer from '../components/preloader/PageCardShimmer';
import QuestionPaperResultSection from "../components/questioners/manage_questin_papers/QuestionPaperResultSection";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import DataTableResult from '../components/datatables/DataTableResult'
import gql from "graphql-tag";
import { graphql } from "react-apollo";



import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import ManageStudentResult from "../components/questioners/manage_questin_papers/ManageStudentResult";
import { Container } from "react-bootstrap";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";


const FETCH_EXAMS = gql`
  query($institution_id: Int!, $exam_paper_id: Int, $page: Int, $limit: Int) {
    manageQuestions(institution_id: $institution_id, exam_paper_id: $exam_paper_id, page: $page, limit: $limit) {
        totalCount
        papers {
            id
            name
            exam_type
            no_of_sets
            start_time
            end_time
            is_completed
            filename
            exam_name
            class
            class_id
            sub_exam_type
            total_question_count
            section
            branch
            student_results{
              session_id
              student_name
              mobile
              father_phone
              email
              branch_id
              class_id
              section_id
              correct
              wrong
              not_answered
              total_questions
              correct_marks
              negative_marks
              total_marks
              accuracy
              speed
              attempted_exam
            }
            exam_questions{
              id
              subject
              chapter
              question
              option1
              option2
              option3
              option4
              qtype
              complexity
              chapter_name
              compquestion
              list1type
              list2type
              mat_question
              answer
              inputquestion
            }
            result_graph{
              limit
              percentage
            }
        }
    }
  }
`;


const GET_GLOBALS = gql`
 query($institution_id: Int!) {
          globals(institution_id: $institution_id) {
            exams{
            id
            exam
            exam_subjects{
                subject_id
            }
            avg_question_time
        }
            globalBranches{
              id
              branch_name
            }
            globalSections{
              id
              section_name
            }
            classes{
              id
              class
            }
            subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
          }
        }
`;


const ORGANISATION_PROFILE = gql` 
query($institution_id: Int!) {
    getOrganisationProfile(institution_id: $institution_id){
        id
        organisation_name
        logo
        
    }
}
`;

class QuestionPaperResult extends Component {
  state = {
    // Shared branch/section filter — set by ManageStudentResult's dropdowns and also
    // consumed by QuestionPaperResultSection, so choosing a branch/section updates the
    // summary cards + chart at the top AND the student table below from one selector.
    filterBranch: "",
    filterSection: "",
  };
  handleResultFilterChange = (branch, section) => {
    this.setState({ filterBranch: branch, filterSection: section });
  };
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {

    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;

    const getExams = this.props.getExams;
    const loading2 = getExams.loading;
    const error2 = getExams.error;

    const getOrganisationProfile = this.props.getOrganisationProfile;
    const loading3 = getOrganisationProfile.loading;
    const error3 = getOrganisationProfile.error;

    //if (loading2) return null;
    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }
    if (error3 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }
console.log("mkkkkkkkkkkkkkkkkkkk",this.props.history.location);

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />

        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          {(loading1 == true ||  loading2 == true ||  loading3 == true) && (<PageCardShimmer filters={4} cols={8} />)}
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            {
              !loading1 && !loading2 && (
                <div className="main-content">
                  <Container fluid>
                  <QuestionPaperResultSection
                    getExams={getExams.manageQuestions.papers}
                    getOrganisationProfile={getOrganisationProfile.getOrganisationProfile}
                    globals={globals.globals}
                    filterBranch={this.state.filterBranch}
                    filterSection={this.state.filterSection}
                  />
                  </Container>
                  <Container fluid>
                  <ManageStudentResult
                    globals={globals.globals}
                    student_results={getExams.manageQuestions.papers[0]?.student_results || []}
                    onFilterChange={this.handleResultFilterChange} />
                    </Container>
                </div>)}

          </div>
          <Footer />
        </div>
      </div>
    );
  }
}



export default withRouter(
  compose(
    graphql(
      GET_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          },
          fetchPolicy: 'cache-and-network'
        }),
        name: "globals"
      }
    ),
    graphql(FETCH_EXAMS,

      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_paper_id: parseInt(props.location.state.exam_id),
            page: 1,
            limit: 10
          }
          ,
          fetchPolicy: 'cache-and-network'
        }), name: "getExams"
      }),
      graphql(ORGANISATION_PROFILE,
        {
          options: props => ({
            variables: {
              institution_id: parseInt(Cookies.get("institutionid"))
            }
            ,
            fetchPolicy: 'cache-and-network'
          }), name: "getOrganisationProfile"
        })

  )(QuestionPaperResult)
);


